export default {
  primary: '#005F99',
  secondary: '#00AFB9',
  accent: '#FDFCDC',
};
